import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';

const CheckIcon = ({ className, size }) => {
  if (size === 'small') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={getClassName(className)}
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          clipRule="evenodd"
        />
      </svg>
    );
  }

  return (
    <svg
      className={getClassName(className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="M5 13l4 4L19 7"
      />
    </svg>
  );
};

CheckIcon.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  size: PropTypes.oneOf(['small', 'medium']),
};

CheckIcon.defaultProps = {
  className: 'w-4 h-4',
  size: 'small',
};

export default CheckIcon;
